import { render, staticRenderFns } from "./NextDeadlines.vue?vue&type=template&id=7fb8c7d2&scoped=true"
import script from "./NextDeadlines.vue?vue&type=script&lang=js"
export * from "./NextDeadlines.vue?vue&type=script&lang=js"
import style0 from "./NextDeadlines.vue?vue&type=style&index=0&id=7fb8c7d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb8c7d2",
  null
  
)

export default component.exports